module.exports = __webpack_public_path__ + "img/icon_tick_select@3x.faf5d62d.png";